export enum WidgetView {
  HOME = "home",
  CHAT = "chat",
  CHATS = "chats",
  ACCOUNT = "account",
  ORDERS = "orders",
}
